(function () {
  "use strict";

  angular.module("physicalFairs")
    .controller("PhysicalFairEventContactsController", PhysicalFairEventContactsController);

    PhysicalFairEventContactsController.$inject = ["ExpoService", "CountriesNewService", "semesters", "expos", "$timeout"];

  function PhysicalFairEventContactsController(ExpoService, CountriesNewService, semesters, expos, $timeout) {
    
    var vm = this;
    vm.flag = false;
    vm.expoSelected = [];
    vm.getByFilter = getByFilter;
    vm.getByFilterCsv = getByFilterCsv;
    vm.getExposBySemester = getExposBySemester;
    vm.semesterSelected = '--- All ---';
    vm.getCountries = getCountries;
    vm.getRegions = getRegions;
    vm.yesNo = [{id:0, name : 'No'},{id: 1, name : 'Yes'}];
    vm.semesterSelected = [];
    vm.countrySelected = [];
    vm.regionSelected = [];
    vm.onlyTSWEvents = -1;

    function getByFilter() {
      vm.flag = false;
      let query = {};

      if(vm.expoSelected.length > 0) {
        query['expo_id'] = JSON.stringify(vm.expoSelected);
      }

      if(vm.onlyTSWEvents.id != -1) {
        query['fpp_events'] = vm.onlyTSWEvents.id;
      }

      if(vm.semesterSelected.length > 0) {
        query['semester'] = [];
        angular.forEach(vm.semesterSelected, function(value, key) {
            query['semester'].push(value);
        });
        query['semester'] = query['semester'].join();
      }

      if(vm.countrySelected.length > 0) {
        query['country_id'] = [];
        angular.forEach(vm.countrySelected, function(value, key) {
            query['country_id'].push(value);
        });
        query['country_id'] = query['country_id'].join();
      }

      if(vm.regionSelected.length > 0) {
        query['region_id'] = [];
        angular.forEach(vm.regionSelected, function(value, key) {
            query['region_id'].push(value);
        });
        query['region_id'] = query['region_id'].join();
      }

      ExpoService.eventContacts(query).then(function(response){
        vm.flag = true;
        vm.eventContacts = response.data;
      });
    }

    function getExposBySemester () {
      let query = {};

      if(vm.semesterSelected.length == 1) {
        query['semester'] = vm.semesterSelected[0];
      }

      ExpoService.getExpoBySemester(query).then(function(response){
        vm.expos = response.data;
      });
    }

    function getCountries () {
      CountriesNewService.getCountries().then(function(response){
          vm.countries = response.data;
      });
    }

    function getRegions () {
      vm.regionSelected = [];
      if(vm.countrySelected.length == 1) {
        CountriesNewService.getRegions(vm.countrySelected[0]).then(function(response) {
            vm.regions = response.data;
        }).catch(function(err) {

        });
      }
    }

    function getByFilterCsv () {
      let query = {};

      if(vm.expoSelected.length > 0) {
        query['expo_id'] = JSON.stringify(vm.expoSelected);
      }

      if(vm.semesterSelected.length > 0) {
        query['semester'] = [];
        angular.forEach(vm.semesterSelected, function(value, key) {
            query['semester'].push(value);
        });
        query['semester'] = query['semester'].join();
      }

      if(vm.countrySelected.length > 0) {
        query['country_id'] = [];
        angular.forEach(vm.countrySelected, function(value, key) {
            query['country_id'].push(value);
        });
        query['country_id'] = query['country_id'].join();
      }

      if(vm.regionSelected.length > 0) {
        query['region_id'] = [];
        angular.forEach(vm.regionSelected, function(value, key) {
            query['region_id'].push(value);
        });
        query['region_id'] = query['region_id'].join();
      }

      ExpoService.eventContactsCsv(query).success(function(data) {
        var anchor = document.createElement("a");
        anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
        anchor.target = "_blank";
        anchor.download = `physical_fair_event_contacts.csv`;
        document.body.appendChild(anchor);
        anchor.click();
        $timeout(function () {
          anchor.remove();
        }, 50);
      });
    }

    function activate() {
      vm.getCountries();

      vm.expos = expos;
      vm.semesters = semesters;
      vm.expos.unshift({'id': -1, 'name': '--- All ---'});
      vm.semesters.unshift({'id': -1, 'name': '--- All ---'});
    }
    
    activate();
  }
})();
